/* eslint-disable */
import {
  VuexModule,
  Module,
  Mutation,
  Action,
} from 'vuex-module-decorators';
import BankService from '@/services/BankService';

const bankService = new BankService();

@Module({ namespaced: true })
export default class BankConfig extends VuexModule {
  public useHengPay: boolean = false;
  public useZappay: boolean = false;
  public useBank: boolean = false;
  public useBigPay: boolean = false;

  @Mutation
  setConfig(payload: { useHengPay: boolean, useZappay: boolean, useBank: boolean, useBigPay: boolean }) {
    this.useHengPay = payload.useHengPay;
    this.useZappay = payload.useZappay;
    this.useBank = payload.useBank;
    this.useBigPay = payload.useBigPay;
  }

  @Action({ rawError: true })
  // eslint-disable-next-line class-methods-use-this
  async fetchConfig() {
    try {
      const { data } = await bankService.getConfig();
      console.log(data);
      this.context.commit('setConfig', data);
    } catch (e) {
      console.log(e);
    }
  }
}
